import { minidenticon } from 'minidenticons';
import Image from 'next/image';
import { useMemo } from 'react';

export const MinidenticonImg = ({ username, ...props }: { username: string; width?: number; height?: number }) => {
  const svgURI = useMemo(() => 'data:image/svg+xml;utf8,' + encodeURIComponent(minidenticon(username)), [username]);
  return <Image src={svgURI} alt={username} width={props.width ?? 40} height={props.height ?? 40} {...props} />;
};
